// @flow

import Logger from 'app/lib/Logger';

export default class IconLoader {
  static types = {
    raw: 'raw',
    component: 'component'
  }

  static load(loader: $Keys<typeof IconLoader.types>, name: string) {
    const path = `./${name}.svg`;
    const context = CONTEXTS[loader];

    try {
      switch (loader) {
        case this.types.raw:
          return context(path);
        case this.types.component:
          return context(path).default;
      }
    } catch (err) {
      Logger.error(`[Icon] No icon found for "${name}"`, err);
    }

    return context('./placeholder.svg');
  }
}

const CONTEXTS = {
  [IconLoader.types.raw]: require.context('!raw-loader!./', false, /\.svg$/),
  [IconLoader.types.component]: require.context('!@svgr/webpack?{"svgo": false, "svgoConfig": {"removeViewBox": false}, "replaceAttrValues":{"#010202": "currentColor"}}!./', false, /\.svg$/)
};
